import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { useHistory } from 'react-router-dom';
import Common from '../Common/common';

const BenefitUse = ({ benefitId, siteId, mallId, shopCode, customerId, liffAccessToken }) => {
  const history = useHistory();
  const [benefitInfo, setBenefitInfo] = useState([]);
  const [values, setValues] = useState({
    address: "",
    postal_code: "",
    name: "",
    email: "",
    phone_number: ""
  });
  const [benefitLotteryTicketList, setBenefitLotteryTicketList] = useState([]);

  const refreshData = useCallback(async () => {
    try {
      const benefit = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${siteId}/${benefitId}/findone`, { customer_id: customerId, line_id: liffAccessToken, mall_id: mallId })).data;
      const benefit_lottery_ticket_list = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${siteId}/issuelist/`, { customer_id: customerId, line_id: liffAccessToken, mall_id: mallId })).data;
      setBenefitLotteryTicketList(benefit_lottery_ticket_list.filter(benefit => benefit.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED));
      setBenefitInfo(benefit);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, benefitId, mallId, customerId, liffAccessToken]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleDeliveryApplyLotteryClick = async () => {
    if (!String(values.address)) {
      window.alert('住所を入力してください。');
      return;
    }
    // if (!String(values.postal_code)) {
    //   window.alert('郵便番号を入力してください。');
    //   return;
    // }
    if (!String(values.name)) {
      window.alert('氏名を入力してください。');
      return;
    }
    if (!String(values.phone_number)) {
      window.alert('電話番号を入力してください。');
      return;
    }
    // if (!String(values.email)) {
    //   window.alert('メールアドレスを入力してください。');
    //   return;
    // }
    if (!/^\d{7}$/.test(values.postal_code)) {
      window.alert('郵便番号は7桁の数字で入力してください。');
      return;
    }
    if (!/^[\w\-.]+@[\w\-.]+\.[A-Za-z]{2,}$/.test(values.email)) {
      window.alert('正しいメールアドレスを入力してください。');
      return;
    }
    if (!/^\d{10,11}$/.test(values.phone_number.replace(/-/g, ''))) {
      window.alert('電話番号は10桁または11桁の数字で入力してください。');
      return;
    }
    if (!window.confirm(`この内容で抽選に応募します。よろしいですか？`)) {
      return;
    }
    for (var count = 0; count < benefitLotteryTicketList.length; count++) {
      var data = {
        'site_id': siteId,
        'benefit_lottery_ticket_id': benefitInfo.benefit_lottery_ticket_id,
        'customer_id': customerId,
        'line_id': liffAccessToken,
        'mall_id': mallId,
        'status': constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED,
        'address': values.address ? values.address : "",
        'postal_code': values.postal_code ? values.postal_code : "",
        'phone_number': values.phone_number ? values.phone_number : "",
        'email': values.email ? values.email : "",
        'name': values.name ? values.name : "",
        'issue_count': benefitLotteryTicketList[count].issue_count,
        'receiving_type': constClass.RECEIVING_TYPE.TICKET_DELIVERY
      };
      try {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer_benefit_lottery_ticket/line/delivery`, data);
      } catch (err) {
        console.log(err);
      }
    }
    history.push(`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.BENEFITFINISH}`);
  }

  const handleApplyLotteryClick = async () => {
    if (!window.confirm(`抽選に応募します。よろしいですか？`)) {
      return;
    }
    for (var count = 0; count < benefitLotteryTicketList.length; count++) {
      const data = {
        'site_id': siteId,
        'customer_id': customerId,
        'line_id': liffAccessToken,
        'mall_id': mallId,
        'benefit_lottery_ticket_id': benefitInfo.benefit_lottery_ticket_id,
        'status': constClass.BENEFIT_LOTTERY_TICKET_STATUS.APPLIED,
        'issue_count': benefitLotteryTicketList[count].issue_count,
        'receiving_type': benefitInfo.receiving_type
      };
      try {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer_benefit_lottery_ticket/line`, data);
      } catch (err) {
        console.log(err);
      }
    }
    history.push(`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.BENEFITFINISH}`);
  }

  const checkInvalid = () => {
    const check = !values.postal_code || !values.address || !values.name || !values.phone_number || !values.email ? true : false;
    return check;
  }

  // const handleTicketCountChange = (e) => {
  //   const value = Math.max(1, Number(e.target.value));
  //   setTicketCount(value);
  // }

  return (
    <div id="benefitInfoUse" className="px-0-env">
      <div className="mx-3 mt-1 mb-3">
        <div className="row mx-0 px-3 pt-2 pb-1">
          {benefitInfo.benefit_lottery_ticket_detail_image_url && benefitInfo.benefit_lottery_ticket_image_url && <img className="benefit-detail-image" src={`/${siteId}/${constClass.BENEFIT_LOTTERY_TICKET_DETAIL_IMAGE_DIR}${benefitInfo.benefit_lottery_ticket_detail_image_url}`} alt={benefitInfo.benefit_title} style={{ objectFit: 'cover' }} />}
          {!benefitInfo.benefit_lottery_ticket_detail_image_url && benefitInfo.benefit_lottery_ticket_image_url && <img className="benefit-detail-image" src={`/${siteId}/${constClass.BENEFIT_LOTTERY_TICKET_IMAGE_DIR}${benefitInfo.benefit_lottery_ticket_image_url}`} alt={benefitInfo.benefit_title} style={{ objectFit: 'cover' }} />}
          {!benefitInfo.benefit_lottery_ticket_detail_image_url && !benefitInfo.benefit_lottery_ticket_image_url && <img className="benefit-detail-image" src={`/${siteId}/nodetailimage.png`} alt="nodetailimage" style={{ objectFit: 'cover' }} />}
        </div>
        <div className="row mx-0 px-3-env pt-2">
          <div className="col py-1 px-1 mt-2 align-self-center text-center">
            <h4 className="p-0 m-0 benefit_title_infouse">{benefitInfo.benefit_lottery_ticket_title}</h4>
          </div>
          {benefitInfo.benefit_lottery_ticket_summary && <div className="p-0 m-0 mt-2 benefit_summary_infouse">{Common.getBrString(benefitInfo.benefit_lottery_ticket_detail)}</div>}
        </div>
        <div className='vector20'></div>
        <div className="col py-1">
          ※当選者には後日、当選通知が送られます。<br />
          落選の場合は通知はございませんのでご了承ください。
        </div>
        {benefitInfo.receiving_type === constClass.RECEIVING_TYPE.TICKET_DELIVERY &&
          <React.Fragment>
            <div className="col py-1">
              賞品によりお渡し方法が異なります。<br />
              ※チケットの郵送およびメールでの連絡をさせていただく賞品がございます。​
              入力に不備があった場合、当選が無効となる場合がございます。
            </div>
          </React.Fragment>
        }
        <div className="mx-0 px-3-env pb-1">
          {benefitInfo.receiving_type === constClass.RECEIVING_TYPE.TICKET_DELIVERY &&
            <React.Fragment>
              <div className="row mt-3">
                <div className={`col-auto px-0 align-self-center`}><span>住所</span></div>
                <input
                  type="text"
                  name="address"
                  className="form-control mb-2"
                  placeholder="住所"
                  value={values.address}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>郵便番号</span></div>
                <input
                  type="text"
                  name="postal_code"
                  className="form-control mb-2"
                  placeholder="郵便番号"
                  value={values.postal_code}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>電話番号</span></div>
                <input
                  type="text"
                  name="phone_number"
                  className="form-control mb-2"
                  placeholder="電話番号"
                  value={values.phone_number}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>メールアドレス</span></div>
                <input
                  type="text"
                  name="email"
                  className="form-control mb-2"
                  placeholder="メールアドレス"
                  value={values.email}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>氏名</span></div>
                <input
                  type="text"
                  name="name"
                  className="form-control mb-4"
                  placeholder="氏名"
                  value={values.name}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="row mt-3 align-items-center justify-content-center text-center">
                <div className="col-auto"><span>使用する抽選券枚数</span></div>
                <div className="col-auto">
                  <select value={ticketCount} onChange={handleTicketCountChange} className="form-control">
                    {[...Array(benefitLotteryTicketList.length)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                  </select>
                </div>
              </div> */}
              <button
                disabled={checkInvalid()}
                onClick={handleDeliveryApplyLotteryClick}
                className="button text-black bg-lightwhite">
                抽選に応募する
              </button>
            </React.Fragment>
          }
          {(benefitInfo.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON ||
            benefitInfo.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR ||
            benefitInfo.receiving_type === constClass.RECEIVING_TYPE.POINT) &&
            <React.Fragment>
              {/* <div className="row mt-3 align-items-center justify-content-center text-center">
                <div className="col-auto"><span>使用する抽選券枚数</span></div>
                <div className="col-auto">
                  <select value={ticketCount} onChange={handleTicketCountChange} className="form-control">
                    {[...Array(benefitLotteryTicketList.length)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                  </select>
                </div>
              </div> */}
              <button
                onClick={handleApplyLotteryClick}
                className="button text-black bg-lightwhite">
                抽選に応募する
              </button>
            </React.Fragment>
          }
        </div>
      </div>
    </div>
  )
}

export default BenefitUse;